import store from "@frameworks/web/redux/store/index";
import { GETPROFILEPIC, GETPROFILEPIC_ERROR, GETPROFILEPIC_HIDE_ERROR, GETPROFILEPIC_START_LOADER, GETPROFILEPIC_STOP_LOADER } from "../interface/IGetProfilePic";
class GetProfilePicActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getProfilePicData(data) {
        this.dispatch({
            type: GETPROFILEPIC,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: GETPROFILEPIC_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: GETPROFILEPIC_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: GETPROFILEPIC_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: GETPROFILEPIC_STOP_LOADER,
        });
    }
}
export default GetProfilePicActions;
